<template>
    <v-form ref="form" v-model="valid">
        <v-list>
            <v-list-item>
                <SoliText
                    v-model="value.name"
                    label="Venue Name"
                    icon="storefront"
                    :rules="[() => !!value.name || 'Venue name is required']"
                />
            </v-list-item>
            <v-list-item>
                <SoliAddress
                    @setAddress="
                        value.address = `${$event.address}, ${$event.city}`
                    "
                    :rules="[() => !!value.address || 'Address is required']"
                />
            </v-list-item>
        </v-list>
    </v-form>
</template>

<script>
export default {
    data() {
        return {
            value: {
                name: null,
                address: null,
            },
            valid: !!this.recommended,
        };
    },
    watch: {
        valid(valid) {
            this.$emit("valid", !valid);
        },
        value: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>
